(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accelerated-checkout"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__olgasBuyNowReady) return;
    window.__olgasBuyNowReady = true;

    document.addEventListener('click', async function (event) {
      var button = event.target.closest('[data-olgas-buy-now]');
      if (!button) return;
      event.preventDefault();

      var form = button.closest('form');
      if (!form) return;

      var wrapper = button.closest('.olgas-buy-now-wrapper');
      var errorBox = wrapper ? wrapper.querySelector('[data-olgas-buy-now-error]') : null;
      var addButton = form.querySelector('.add-to-cart-button');
      if (addButton && addButton.disabled) {
        if (errorBox) {
          errorBox.textContent = 'Esta referencia está agotada. Elige otro color o tamaño.';
          errorBox.hidden = false;
        }
        return;
      }

      button.setAttribute('aria-busy', 'true');
      if (errorBox) errorBox.hidden = true;

      try {
        var response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });
        if (!response.ok) {
          var data = await response.json().catch(function () { return {}; });
          throw new Error(data.description || data.message || 'No pudimos agregar este producto.');
        }
        window.location.href = '/checkout';
      } catch (error) {
        button.removeAttribute('aria-busy');
        if (errorBox) {
          errorBox.textContent = error.message;
          errorBox.hidden = false;
        }
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
